import React, { useState } from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { bindActionCreators } from 'redux'
import uiActionCreators from '../../State/Store/UI/UI.actions'
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import CustomPhoneInput from '../CustomPhoneInput/CustomPhoneInput.component'
import Modal from '../Modal/Modal.component'
import Spinner from '../Spinner/Spinner.component'
import EditMobileNumberModalPropTypes from './EditMobileNumberModal.component.props'
import editMobileNumberModalStyles from './EditMobileNumberModal.component.styles'
import createUserProfileActionCreators from 'State/Store/UserProfile/UserProfile.actions'
import userProfileCurrentSelector from 'State/Store/UserProfile/Selectors/UserProfileCurrent.selector'
import withServices from 'Contexts/Services/WithServices.context'
import SnackbarActionCreators from 'State/Store/Snackbar/SnackbarActionCreators'

interface Props {
  open: boolean,
  title?: string,
  extraInfo?: string,
  mobileNumber?: string,
  onSuccess(mobileNumber: string): void,
  onCancel(): void,
  onError?(): void,
}
interface InjectedProps {
  classes: any,
  userProfile: any,
  services: any,
  actions: any,
}
const EditMobileNumberModal = (props: Props & InjectedProps) => {
  const {
    open,
    title = 'Edit Mobile Number',
    extraInfo = '',
    mobileNumber = '',
    onSuccess,
    onCancel = () => {},
    onError = () => {},

    classes,
    userProfile,
    services,
    actions: {
      updateUserProfile,
      openSnackbar,
    },
  } = props

  const [ updatedMobileNumber, setUpdatedMobileNumber ] = useState<string>(mobileNumber)
  const [ isSaving, setIsSaving ] = useState<boolean>(false)
  const [ isValid, setIsValid ] = useState<boolean>(false)

  const handleSave = async (mobileNumber: string) => {
    try {
      setIsSaving(true)
      await services.userService.updateUserProfile({ ...userProfile, mobilePhone: mobileNumber })
      updateUserProfile({ profile: { ...userProfile, mobilePhone: mobileNumber } })
      onSuccess(updatedMobileNumber)
      openSnackbar({
        message: `Your profile has been updated.`,
      })
    } catch (ex) {
      onError()
    } finally {
      setIsSaving(false)
    }
  }
  const handleNumberChange = (id: any, number: string, error: boolean, isOriginalNumber: boolean) => {
    setUpdatedMobileNumber(number)
    if (number) {
      setIsValid(!error)
    } else {
      // empty is not allowed
      setIsValid(false)
    }
  }
  return (
    <Modal
      preventFullScreen
      hideCloseButton
      minWidth={400}
      paperClasses={classes.paperClasses}
      content={
        <Grid container>
          {
            extraInfo
            && (
              <Grid item xs={12}>
                <Typography variant='body2'>
                  { extraInfo }
                </Typography>
              </Grid>
            )
          }
          <Grid item xs={12} className={classes.notificationsPanelContainer}>
            <CustomPhoneInput
              id={'modalPhoneId' as any}
              label='Mobile'
              onPhoneNumberChange={handleNumberChange}
              value={updatedMobileNumber}
            />
          </Grid>
        </Grid>
      }
      maxWidth='sm'
      open={open}
      title={
        <Grid container>
          <Grid item xs={12}>
            { title }
          </Grid>
        </Grid>
      }
      footer={
        <Grid className={classes.textAlignRight} container justify='flex-end' spacing={2}>
          <Grid item>
            <Button
              className={classes.button}
              color='default'
              onClick={() => {
                onCancel()
              }}
              variant='contained'
            >
              {`Cancel`}
            </Button>
          </Grid>
          <Grid item>
            <Button
              className={classes.button}
              color='primary'
              disabled={isSaving || !isValid}
              onClick={() => {
                handleSave(updatedMobileNumber)
              }}
              variant='contained'
            >
              {isSaving ? <Spinner loaderStyles={classes.spinner} size={16} /> : `Save`}
            </Button>
          </Grid>
        </Grid>
      }
    />
  )
}

// EditMobileNumberModal.propTypes = EditMobileNumberModalPropTypes

export default compose<Props & InjectedProps, Props>(
  withStyles(themeCreateInjectableStyles(editMobileNumberModalStyles) as any, { withTheme: true }),
  withServices,
  connect(
    (state: any) => ({
      userProfile: userProfileCurrentSelector(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          updateUserProfile: createUserProfileActionCreators.updateUserProfile,
          openSnackbar: SnackbarActionCreators.openSnackbar,
        },
        dispatch,
      ),
    }),
  ),
)(EditMobileNumberModal)
